export const selectedCountry = {
  placeholder: "Selecione um país",
};
